module.exports = __webpack_public_path__ + "static/img/excel.36af950e.png";